
import Vue from 'vue';
import VueListboxMultiselect from '@banneredge/vue-listbox-multiselect';
import dataSet from './usCities';

export default Vue.extend({
  name: 'Groups',
  components: {
    VueListboxMultiselect,
  },
  data() {
    return {
      selectedList: [
        { id: 'Alabama-Alabaster', value: 'Alabaster', group: 'Alabama' },
        { id: 'California-Agoura Hills', value: 'Agoura Hills', group: 'California' },
      ],
    };
  },
  methods: {
    async search(query: string): Promise<any[]> {
      const ids = this.selectedList.map((x) => x.id);
      let subset = dataSet.filter((x) => !ids.includes(`${x.state}-${x.city}`));

      if (!query) {
        subset = subset.slice(0, 100);
      } else {
        const q = query.toLowerCase();
        subset = subset.filter((x) => x.city.toLowerCase().includes(q)
          || x.state.toLowerCase().includes(q));
        subset = subset.slice(0, 100);
      }

      return subset.map((x: any) => ({
        id: `${x.state}-${x.city}`,
        value: x.city,
        group: x.state,
      }));
    },
  },
});
